var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc4Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.769,
    height: 92,
    viewBox: "0 0 177.769 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#f78f2d;}.a{font-size:23px;font-family:Poppins-Italic, Poppins;font-style:italic;}.c{fill:#F78F2D;}.d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-162.75 -193.73)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(266.519 253.434)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "health")), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.239,
    cy: 4.239,
    r: 4.239,
    transform: "translate(255.55 246.123)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(162.75 193.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M219,300.246V274.71h8.207v25.536Z",
    transform: "translate(-33.168 -47.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M272.933,276.46q3.307,2.844,3.3,8.113H268.4a5.088,5.088,0,0,0-1.169-3.529,4.224,4.224,0,0,0-3.32-1.3,4.272,4.272,0,0,0-3.656,1.559,7.1,7.1,0,0,0-1.169,4.341v2.376a7.127,7.127,0,0,0,1.169,4.325,4.156,4.156,0,0,0,3.582,1.576,4.868,4.868,0,0,0,3.6-1.231,4.68,4.68,0,0,0,1.231-3.451h7.571q0,5.232-3.213,8.014t-9.073,2.782q-6.537,0-9.893-3.34t-3.361-9.873q0-6.537,3.361-9.877t9.893-3.328Q269.633,273.62,272.933,276.46Z",
    transform: "translate(-51.86 -47.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M331.7,278.423a48.235,48.235,0,0,1-3.619,5.745,42.835,42.835,0,0,1-3.919,4.731h7.349v-5.281a37.031,37.031,0,0,0,2.339-3.861,17.453,17.453,0,0,0,1.559-3.693h3.156v12.844h3.562v5.458h-3.562V299.6h-7.054v-5.232H319.08v-5.531a50.768,50.768,0,0,0,3.972-7.017,53.824,53.824,0,0,0,3.156-8.207h7.275A15.185,15.185,0,0,1,331.7,278.423Z",
    transform: "translate(-92.18 -47.101)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc4Logo);
export default __webpack_public_path__ + "static/media/ic4-logo.87543c71b78874ec0cbe2d9425ca856a.svg";
export { ForwardRef as ReactComponent };